function normalizePackageCode(value) {
  const raw = String(value || "").trim().toUpperCase();
  if (!raw) return "";
  if (raw === "STARTER" || raw === "BASIC") return "BASIC";
  if (raw === "PRO") return "PRO";
  if (raw === "AGENCY") return "AGENCY";
  if (raw === "TRIAL") return "TRIAL";
  return "";
}

export function isTrial(code) {
  return normalizePackageCode(code) === "TRIAL";
}

export function isBasic(code) {
  return normalizePackageCode(code) === "BASIC";
}

export function isPro(code) {
  return normalizePackageCode(code) === "PRO";
}

export function isAgency(code) {
  return normalizePackageCode(code) === "AGENCY";
}

export function isProOrAbove(code) {
  const c = normalizePackageCode(code);
  return c === "PRO" || c === "AGENCY";
}

export function normalizePackageTierCode(code) {
  return normalizePackageCode(code);
}
